import { Api } from '@axiom/ui';
import type {
  CandidateReputationDetails,
  CandidateReputationHistory,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateReputationDetailsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readReputationHistory({
    reputationId,
  }: {
    reputationId: CandidateReputationDetails['id'];
  }) {
    return super.read<{ data: CandidateReputationHistory }>({
      endpoint: `/candidateReputationDetails/${reputationId}/history`,
      method: 'GET',
    });
  }

  async invalidateReputationHistory({
    reputationId,
  }: {
    reputationId: CandidateReputationDetails['id'];
  }) {
    return super.invalidate(
      `/candidateReputationDetails/${reputationId}/history`
    );
  }
}

export const CandidateReputationDetailsApi =
  new CandidateReputationDetailsApiClass();
